import {differenceInDays} from 'date-fns';

import {isEmpty, isNil} from 'ramda';

import {parseDate} from 'shared/web';

/**
 * Price-map "sold recently" (0–30 days) band — occurrence-based only.
 * Live `just_sold` does not encode sold duration, so it must not influence this band.
 */
export function isSoldIn30Days(car: {is_sold: boolean | null; last_occurrence: string | null}) {
  if (isNil(car.last_occurrence) || isEmpty(car.last_occurrence)) {
    return false;
  }
  return !!car.is_sold && differenceInDays(new Date(), parseDate(car.last_occurrence)) <= 30;
}
